import { useCallback, useEffect, useMemo, useState } from "react";
import { packkyAxiosInstance } from "../api/axiosInstance";
import { ENDPOINTS } from "../api/endpoints";

export const useOrderTracking = (taskId) => {
  const [orderDetails, setOrderDetails] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const actualTaskId = useMemo(() => {
    const pathValue = window.location.pathname.replace("/", "");

    // URL: /20779-126200
    if (pathValue.includes("-")) {
      return pathValue.split("-")[0];
    }

    return String(taskId || "");
  }, [taskId]);

  const fetchRestaurantDetails = useCallback(async () => {
    if (!actualTaskId) {
      setOrderDetails(null);
      setError("");
      return null;
    }

    try {
      setLoading(true);
      setError("");

      const payload = {
        taskId: actualTaskId,
      };

      console.log("Restaurant Details Payload:", payload);

      const res = await packkyAxiosInstance.post(
        ENDPOINTS.RESTAURANT_DETAILS,
        payload,
      );

      console.log("Restaurant Details Response:", res?.data);

      if (res?.data?.responseCode !== "00") {
        throw new Error(
          res?.data?.responseMessage ||
            "Restaurant details fetch nahi ho payi.",
        );
      }

      const data = res?.data?.data || null;

      setOrderDetails(data);

      return data;
    } catch (err) {
      console.error("Restaurant details API error:", err);

      setError(
        err?.response?.data?.responseMessage ||
          err?.response?.data?.message ||
          err?.message ||
          "Restaurant details fetch nahi ho payi.",
      );

      setOrderDetails(null);
      return null;
    } finally {
      setLoading(false);
    }
  }, [actualTaskId]);

  useEffect(() => {
    fetchRestaurantDetails();
  }, [fetchRestaurantDetails]);

  return {
    orderDetails,
    loading,
    error,
    fetchRestaurantDetails,
  };
};
